"use client";

import { trackEvent } from "./track-event";

interface SearchTrackingProps {
	query?: string;
	filters?: Record<string, unknown>;
	resultCount?: number;
	location?: string;
	additionalOptions?: Record<string, unknown>;
}

/**
 * Track search events
 * Based on events from i/webapp/components/unit/search/UnitSearchResults.js
 */
export function trackSearch({
	query,
	filters,
	resultCount,
	location,
	additionalOptions = {},
}: SearchTrackingProps = {}) {
	trackEvent({
		google: {
			event: "Search",
			options: {
				search_term: query,
				result_count: resultCount,
				location: location,
				filters: filters ? JSON.stringify(filters) : undefined,
				...additionalOptions,
			},
		},
		facebook: {
			event: "Search",
			options: {
				search_string: query,
				content_category: "property_search",
				...additionalOptions,
			},
		},
		matomo: {
			event: "property_search",
			options: {
				category: "search",
			},
		},
	});
}

/**
 * Track home page search
 * Based on i/webapp/components/homeold/search.js line 24
 */
export function trackHomeSearch() {
	trackEvent({
		google: {
			event: "home-search",
			options: {
				event_category: "search",
				event_label: "home_page",
			},
		},
		matomo: {
			event: "home_page_search",
			options: {
				category: "search",
			},
		},
	});
}

/**
 * Track property search with filters
 * Enhanced version for property-specific searches
 */
export function trackPropertySearch({ query, filters, resultCount, location }: SearchTrackingProps = {}) {
	trackSearch({
		query,
		filters,
		resultCount,
		location,
		additionalOptions: {
			event_category: "property_search",
		},
	});
}
